import {
  Attachments,
  AttachmentsProps,
  bytesToMegabyteString,
  MEGABYTES
} from 'modules/Assets'
import { ASSET_ACCEPTED_MIME_TYPES } from '@sequencehq/utils'
import { FC } from 'react'

type Props = Omit<AttachmentsProps, 'acceptedMimeTypes' | 'maxFileSizeText'>

const MAX_FILE_SIZE = 5 * MEGABYTES

export const InvoiceAttachments: FC<Props> = props => {
  return (
    <Attachments
      acceptedMimeTypes={ASSET_ACCEPTED_MIME_TYPES.invoices}
      maxFileSizeText={`Max ${bytesToMegabyteString(MAX_FILE_SIZE)} in total across all files`}
      maxFileSize={MAX_FILE_SIZE}
      {...props}
    />
  )
}
